<div class="search-wrapper pMngr adminSearch" [ngClass]="{'searchMinHeight': !searchedAgent }">
    <form [formGroup]="agentSearchForm" (ngSubmit)="onSearch()">
        <div class="">
            <div class="branch-office-admin" >
                <div *ngIf="(isBranchAdminUser && branchAdminOfficeList.length > 0) || (officeManagerAgentSearch && officeManagerOfficeList.length > 0) ">
                    <div class="primaryOfficeInfo" *ngIf="branchAdminOfficeList.length === 1 || officeManagerOfficeList.length === 1">
                        <div class=" user-office-label" *ngIf="branchAdminOfficeList.length === 1">
                            <input class="primary-office-value" autocomplete="off" type="text"
                                [value]="branchAdminOfficeList[0].value" name="officename"
                                 disabled />
                            <span class="highlight"></span>
                            <label class="primary-office-heading">Branch Administrator</label>
                        </div>
                        <div class="" *ngIf="officeManagerOfficeList.length === 1">
                            <input class="primary-office-value" autocomplete="off" type="text"
                                [value]="officeManagerOfficeList[0].value" name="officename" disabled />
                            <span class="highlight"></span>
                            <label class="primary-office-heading">Office Manager</label>
                        </div>
                    </div>
                    <div class="primaryOfficeInfo" *ngIf="branchAdminOfficeList.length > 1">
                        <div class="">
                            <span class="primary-office-heading">Branch Administrator</span>
                        </div>
                    </div>
                    <div class="primaryOfficeInfo" *ngIf="officeManagerOfficeList.length > 1">
                        <div class="">
                            <span class="highlight"></span>
                            <span class="primary-office-heading">Office Manager</span>
                        </div>
                    </div>
                  
                </div>
            </div>
            <div class="search-by-wrapper" 
                 *ngIf="((isBranchAdminUser && branchAdminOfficeList.length >  1) || (officeManagerAgentSearch && officeManagerOfficeList.length > 1)) ||
                 (!isBranchAdminUser && !officeManagerAgentSearch)" >
                <div class="radio-mob" ><strong>Search by:</strong></div>
                <div class="form-group-radio-check">
                    <label class="radio">
                        <input type="radio" [value]="searchByOffice" name="selectedZillowRating"
                            [checked]="searchByOffice" (change)="onSearchByTypeChange(true)" />
                        <i aria-hidden="true" class="icon-radio"></i>
                        Office
                    </label>
                    <label class="radio p-mr-0">
                        <input type="radio" [value]="!searchByOffice" name="selectedZillowRating"
                            [checked]="!searchByOffice" (change)="onSearchByTypeChange(false)" />
                        <i aria-hidden="true" class="icon-radio"></i>
                        Agent
                    </label>
                </div>
            </div>
            <div *ngIf="searchByOffice">
                <div class="floating-form-group">
                    <span class="p-float-label office-search">
                        <p-autoComplete formControlName="officeName" name="officeName"
                            inputId="officeName" [suggestions]="filteredOfficeList"
                            (onSelect)="onSelectOffice($event)" (completeMethod)="filterOfficeList($event)" 
                            field="fieldValue" [dropdown]="true" spellcheck="false" (onDropdownClick)="filterOfficeList($event)"
                            (onKeyUp)="changeOfficeSelection($event)"
                            [showEmptyMessage]="true"
                            [emptyMessage]="'No results found'">
                        </p-autoComplete>
                        <label>Search by Office Name or PC Number</label>
                    </span>
                </div>
                <div class="floating-form-group mr-20">
                    <span class="p-float-label office-search">
                        <p-autoComplete formControlName="agentName" name="agentName"
                            inputId="agentName" [suggestions]="filteredAgentList"
                             (completeMethod)="filterAgentList($event)" (onSelect)="onSelectAgent()"
                            field="value" [virtualScroll] = "virtualLoading" [itemSize] = "33" [dropdown]="true" spellcheck="false" 
                            [showEmptyMessage]="true" onkeydown="return event.key != 'Enter';" (onDropdownClick)="filterAgentList($event)"
                            [emptyMessage]="'No results found'">
                            <ng-template let-pf pTemplate="item" type="search">
                                <div>
                                    <div>{{pf.value}}</div>
                                </div>
                            </ng-template>
                        </p-autoComplete>
                        <label>Agent Name</label>
                    </span>
                </div>
            </div>
            <div *ngIf="!searchByOffice">
                <div class="floating-form-group mr-20">
                    <span class="p-float-label agent-search-input">
                        <p-autoComplete formControlName="agentName" name="agentName"
                            inputId="agentName" [suggestions]="filteredAgentList"
                            (completeMethod)="filterAgentList($event)" 
                             (onSelect)="onSelectAgent()" [virtualScroll] = "virtualLoading" [itemSize] = "33"
                            field="value" onkeydown="return event.key != 'Enter';" [dropdown]="true" spellcheck="false" (onDropdownClick)="filterAgentList($event)"
                            [showEmptyMessage]="true"
                            [emptyMessage]="'No results found'">
                            <ng-template let-pf pTemplate="item" type="search">
                                <div>
                                    <div>{{pf.value}}</div>
                                </div>
                            </ng-template>
                        </p-autoComplete>
                        <label class="agent-search-label">
                            Search by Agent Number, Legal Name, DBA Name
                        </label>
                    </span>
                </div>
            </div>
            <div class="btnHolder add-btnHolder">
                <button type="button" class="primaryBtn" (click)="onSearch()" [disabled]="!selectedAgent">
                    GO
                </button>
                <button type="button" [disabled]="disableClrBtn" class="SecondaryBtn" (click)="onClear()">
                    CLEAR
                </button>
            </div>
            <div class="instrtuction-wrapper" *ngIf="((isBranchAdminUser && branchAdminOfficeList?.length > 1) || !isBranchAdminUser) &&  !searchedAgent">
                <span class="sub-heading">
                    <span class="info">
                        You can search by office or agent to manage their account through Portal Manager
                    </span>
                </span>
            </div>
        </div>
    </form>

</div>
<app-custom-confirm-dialogue
  [customClass]="'custom-modal'"
  [okBtnLabel]="'YES'"
  #confirmCancelModal
  [cancelBtnLabel]="'NO'"
  (onConfirm)="onConfirmSearch()"
>
</app-custom-confirm-dialogue>